import DeleteTermModal from "./DeleteTermModal";

const DeleteTopicModal = ({ modalDetails }) => (
  <DeleteTermModal modalDetails={modalDetails} kind="topic" />
);

export default DeleteTopicModal;
